import type { FaireProductEntity } from "../../entity_types/product";

export const p_eemb47c4rq: FaireProductEntity = {
  token: "p_eemb47c4rq",
  type: "product",
  name: "Big Smile Chunky Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/97db27b9d9e6f5c7479199fbd7019c030f340ca67e91f424685c5609a402fd55.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03f12c33b5665e8ccdafe1fc21cfa5526d5a061e24101ba7e2b7e7fe1e41ba03.png",
    "https://cdn.faire.com/fastly/a5a1c33a35dbe4df035ee2564d2ee14f958f7bac3d3c48ee0a8694e232d96886.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
  ],
  priceDollars: 9,
  description:
    "Big and chunky. It's how we like our desserts and this awesome square notepad. This is the guy you pull out when you need an extra sturdy surface for those big, chunky ideas.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:41.698Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
